import React, { useEffect, useState } from "react";
import { Layout, Typography, Input, Table, Flex, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import type { AppDispatch } from "../redux/store";
import CustomTableLoader from "src/components/common/CustomTableLoader";
import { GetDriverDetails } from "src/redux/actions/DriverAction";

const DriverDetails: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const dataSource = useSelector((state: any) => state.driverdetails.data ?? []);
  const loading = useSelector((state: any) => state.driverdetails.loading);
  const [searchText, setSearchText] = useState<string>("");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const cityid = userData.cityid;
  const { Title } = Typography;

  const columns: any = [
    {
      title: "Cab ID",
      dataIndex: "cab_id",
      key: "cabId",
      align: "center",
      fixed: "left",
    },
    {
      title: "Driver ID",
      dataIndex: "driver_id",
      key: "driver_id",
      align: "center",
      fixed: "left",
    },
    {
      title: "Name",
      dataIndex: "driver_name",
      key: "driver_name",
      align: "center",
    },
    {
      title: "Mobile Number",
      dataIndex: "driver_mobno",
      key: "driver_mobno",
      align: "center",
    },
    {
      title: "Date of Joining",
      dataIndex: "AttachDate",
      key: "AttachDate",
      align: "center",
      // width: 110,
      // render: (text: any) => text.split(",")[0],
    },
  ];

  useEffect(() => {
    dispatch(GetDriverDetails());
  }, []);

  const handleSearch = (value: any) => {
    setSearchText(String(value || ""));
  };

  const filteredDataSource = dataSource.filter((item: any) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );

  return (
    <Layout
      style={{ minHeight: "100vh", overflow: "hidden", position: "relative" }}
    >
      <Flex
        style={{
          background: "whitesmoke",
          rowGap: "20px",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Title
          level={3}
          style={{
            fontSize: "35px",
            fontWeight: "bolder",
            color: "black",
            fontFamily: "serif",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            margin: 0,
          }}
        >
          Driver Details
        </Title>
        <Flex style={{ width: "100%", justifyContent: "end" }}>
          <Input.Search
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onSearch={(value) => handleSearch(value)}
            style={{ width: "20%" }}
          />
        </Flex>
        <Table
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          loading={{
            spinning: loading,
            indicator: <CustomTableLoader />,
          }}
          size="middle"
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 100,
          }}
          dataSource={filteredDataSource}
          columns={columns}
          //   scroll={{ x: "calc(1700px + 20%)", y: 50 * 15 }}
          bordered
          rowKey="bookingId"
        />
      </Flex>
    </Layout>
  );
};

export default DriverDetails;
